import VueRouter from "vue-router";

const ChatPage = () => import("./views/Chat");
const LoginPage = () => import("./views/Login");

export const router = new VueRouter({
  mode: "history",
  routes: [
    { path: "*", component: ChatPage },
    { path: "/login", component: LoginPage }
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = ["/login"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = to.query.token && to.query.token.match(/[\d]*/);

  if (to.query.token != from.query.token) {
    sessionStorage.setItem("chatbotToken", to.query.token);
  }

  return authRequired && !loggedIn ? next("/login") : next();
});
